module.exports = __webpack_public_path__ + "static/media/appstore-4d.c2f835a1.png";